var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 33.8333C27.5654 33.8333 33.8334 27.5652 33.8334 19.8333C33.8334 12.1013 27.5654 5.83325 19.8334 5.83325C12.1014 5.83325 5.83337 12.1013 5.83337 19.8333C5.83337 27.5652 12.1014 33.8333 19.8334 33.8333Z",
    fill: "#FFDA67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64837 27.9387L19.8334 33.8333H7.97712C6.4167 33.8333 5.63795 31.9491 6.74045 30.8466L9.64837 27.9387Z",
    fill: "#FFDA67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6559 21.4811C14.566 21.4811 15.3038 20.7433 15.3038 19.8332C15.3038 18.9231 14.566 18.1853 13.6559 18.1853C12.7457 18.1853 12.0079 18.9231 12.0079 19.8332C12.0079 20.7433 12.7457 21.4811 13.6559 21.4811Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 21.4811C20.7433 21.4811 21.4811 20.7433 21.4811 19.8332C21.4811 18.9231 20.7433 18.1853 19.8332 18.1853C18.9231 18.1853 18.1853 18.9231 18.1853 19.8332C18.1853 20.7433 18.9231 21.4811 19.8332 21.4811Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.011 21.4811C26.9211 21.4811 27.6589 20.7433 27.6589 19.8332C27.6589 18.9231 26.9211 18.1853 26.011 18.1853C25.1008 18.1853 24.363 18.9231 24.363 19.8332C24.363 20.7433 25.1008 21.4811 26.011 21.4811Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 50.1666C42.5929 50.1666 50.1667 42.5927 50.1667 33.2499C50.1667 23.9071 42.5929 16.3333 33.25 16.3333C23.9072 16.3333 16.3334 23.9071 16.3334 33.2499C16.3334 42.5927 23.9072 50.1666 33.25 50.1666Z",
    fill: "#FFAD24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5583 43.0442L33.25 50.1667H47.0487C49.1283 50.1667 50.1696 47.6525 48.6996 46.1825L45.5613 43.0442H45.5583Z",
    fill: "#FFAD24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7137 35.2391C41.8122 35.2391 42.7028 34.3485 42.7028 33.2499C42.7028 32.1513 41.8122 31.2607 40.7137 31.2607C39.6151 31.2607 38.7245 32.1513 38.7245 33.2499C38.7245 34.3485 39.6151 35.2391 40.7137 35.2391Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 35.2391C34.3486 35.2391 35.2392 34.3485 35.2392 33.2499C35.2392 32.1513 34.3486 31.2607 33.25 31.2607C32.1514 31.2607 31.2609 32.1513 31.2609 33.2499C31.2609 34.3485 32.1514 35.2391 33.25 35.2391Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7863 35.2391C26.8849 35.2391 27.7755 34.3485 27.7755 33.2499C27.7755 32.1513 26.8849 31.2607 25.7863 31.2607C24.6877 31.2607 23.7971 32.1513 23.7971 33.2499C23.7971 34.3485 24.6877 35.2391 25.7863 35.2391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatYellow);
export default __webpack_public_path__ + "static/media/icon_chat_yellow.6d83db85.svg";
export { ForwardRef as ReactComponent };